import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import { InfoTip } from '@/components/feedback/InfoTip';

export interface Crumb {
  label: string;
  to?: string;
}

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  breadcrumbs?: Crumb[];
  actions?: ReactNode;
  /** helpTexts anahtarı — sayfa başlığının yanında ⓘ gösterir. */
  helpKey?: string;
}

/** Her sayfanın üstündeki başlık + breadcrumb satırı. */
export function PageHeader({ title, subtitle, breadcrumbs, actions, helpKey }: PageHeaderProps) {
  return (
    <div className="page-header">
      <div>
        <h1 className="page-header__title">
          {title}
          {helpKey && <InfoTip helpKey={helpKey} size={16} />}
        </h1>
        {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
      </div>

      <div className="page-header__actions">
        {actions}
        {breadcrumbs && breadcrumbs.length > 0 && (
          <nav aria-label="Sayfa yolu">
            <ol className="breadcrumb">
              {breadcrumbs.map((crumb, i) => {
                const isLast = i === breadcrumbs.length - 1;
                return (
                  <li
                    key={`${crumb.label}-${i}`}
                    className={`breadcrumb-item${isLast ? ' active' : ''}`}
                    aria-current={isLast ? 'page' : undefined}
                  >
                    {crumb.to && !isLast ? <Link to={crumb.to}>{crumb.label}</Link> : crumb.label}
                  </li>
                );
              })}
            </ol>
          </nav>
        )}
      </div>
    </div>
  );
}
